import React, { useState, useEffect } from "react";
import { wfetch } from "../../../utils/fetch";
import { getApiEndpoint } from "../../../utils/constants/api";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import NavMenu from "./NavMenu";
import IconGroup from "./IconGroup";
import HeaderTop from "./HeaderTop";
import MobileMenu from "./MobileMenu";
import Logo from "./sub-components/Logo";

const Header = ({ currentLanguageCode, navigationId }) => {
    const [content, setContent] = useState({});
    const [scroll, setScroll] = useState(0);
    const [headerTop, setHeaderTop] = useState(0);

    useEffect(() => {
        async function fetchData() {
            const response = await wfetch(
                getApiEndpoint("NAVIGATION", {
                    queryParams: { "@jcr:uuid": navigationId, lang: currentLanguageCode },
                }),
            );

            if (response && response.data.results[0]) setContent(response.data.results[0]);
        }

        if (navigationId) fetchData();
    }, [currentLanguageCode, navigationId]);

    useEffect(() => {
        const header = document.querySelector(".sticky-bar");
        setHeaderTop(header.offsetTop);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = () => {
        setScroll(window.scrollY);
    };

    return (
        <header className="header-area clearfix">
            <div className="header-padding-1 d-none d-lg-block header-top-area">
                <div className="container">
                    {/* header top */}
                    <HeaderTop />
                </div>
            </div>

            <div className={`header-padding-1 sticky-bar header-res-padding clearfix ${scroll > headerTop ? "stick" : ""}`}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-6 col-4">
                            {/* header logo */}
                            <Logo logoClass="logo" />
                        </div>
                        <div className="col-xl-8 col-lg-8 d-none d-lg-block">
                            {/* Nav menu */}
                            <NavMenu content={content} />
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-6 col-8">
                            {/* Icon group */}
                            <IconGroup />
                        </div>
                    </div>
                </div>

                {/* mobile menu */}
                <MobileMenu content={content} />
            </div>
        </header>
    );
};

export default connect()(multilanguage(Header));
